import React from 'react'
// import PropTypes from 'prop-types'
import { Doughnut } from 'react-chartjs-2'
import { Row, Col } from 'reactstrap'
import get from 'lodash/get'
import styled from 'styled-components'

class DoughnutChart extends React.Component {
  render() {
    const header = get(this.props, 'header', '')
    const title = get(this.props, 'title', '')
    const label = get(this.props, 'label')
    const remark = get(this.props, 'remark', '')
    const summary = get(this.props, 'summary')
    const dataSummary = {
      labels: label,
      datasets: [{
        data: summary,
        datalabels: { display: false },
        fillColor: "#79D1CF",
        strokeColor: "#79D1CF",
        backgroundColor: ['#5CB85C', '#7381DE'],
        hoverBackgroundColor: ['#5CB85C', '#7381DE'],
      }],
    }
    const option = {
      cutoutPercentage: 70,
      legend: { display: false },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        },
      },
    }
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <Header>
          { header }
        </Header>
        <ContainerChart>
          <ChartContainer>
            <LabelRow noGutters>
              <LabelChart>{ title }</LabelChart>
            </LabelRow>
            <ChartRow noGutters>
              <ColInfo>
                <RowLabel color='#5CB85C'>
                  <RowContent>
                    <TypeLabel>{ get(label, ['0']) }</TypeLabel>
                  </RowContent>
                  <RowContent>
                    <NumLabel>{ get(summary, ['0']) } %</NumLabel>
                  </RowContent>
                </RowLabel>
                <RowLabel color='#7381DE'>
                  <RowContent>
                    <TypeLabel>{ get(label, ['1']) }</TypeLabel>
                  </RowContent>
                  <RowContent>
                    <NumLabel> { get(summary, ['1']) } %</NumLabel>
                  </RowContent>
                </RowLabel>
                { remark &&
                  <RemarkLabel>{ remark }</RemarkLabel>
                }
              </ColInfo>
              <ColChart>
                <Doughnut data={ dataSummary } options={ option } height={ 150 } />
              </ColChart>
            </ChartRow>
          </ChartContainer>
        </ContainerChart>
      </Wrapper>
    )
  }
}

DoughnutChart.propTypes = {
}
DoughnutChart.defaultProps = {
}

export default DoughnutChart

const ContainerChart = styled.div`
  display: flex;
  justify-content: flex-end;
`
const Wrapper = styled.div`
  margin-top: 10px;
  font-family: 'Gotham';
  margin-bottom: 30px;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 14px;
`
const Container = styled.div`
  padding-left: 1%;
  padding-top: 1%;
  padding-right: 1%;
  color: black;
  font-family: Gotham-Bold;
  font-weight: lighter;
`
const Header = styled.div`
  height: 50px;
  width: 100%;
  background: #404040;
  color: white;
  font-family: 'Gotham-Bold';
  font-weight: lighter;
  display: flex;
  padding-left: 10px;
  align-items: center;
`
const ChartContainer = styled(Container)`
  width: 100%;
  height: 100% ;
  margin-bottom: 0px;
  margin-left: 0px;
  background:#FFFFFF;
  -moz-box-shadow: 1px 2px 4px rgba(0, 0, 0,0.16);
  -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
`
const LabelRow = styled(Row)`
  width: 100%;
  height: 20% ;
`
const ChartRow = styled(Row)`
  width: 100%;
  height: 80% ;
`
const LabelChart = styled.label`
  font-size: 12px;
  margin-left: 5%;
  font-family: 'Gotham-Bold';
  font-weight: bolder;
`
const ColInfo = styled(Col)`
  width: 40%;
  height: 100% ;
`
const ColChart = styled(Col)`
  width: 60%;
  height: 100% ;
  padding-bottom: 5%;
`
const RowLabel = styled(Container)`
  height: 20%;
  margin-left:10%;
  margin-bottom: 10%;
  padding-left: 5%;
  border-left:  8px solid ${props => props.color};
`
const TypeLabel = styled.label`
  font-family: Gotham;
  font-weight: bolder;
  color: #7B7B7B ;
  font-size : 12px ;
  margin-bottom: 0%;
`
const RemarkLabel = styled(TypeLabel)`
  font-size : 12px;
  margin-left: 20px;
`
const NumLabel = styled.label`
  font-family: Gotham-Bold;
  font-weight: bolder;
  font-size : 12px;
  margin-bottom: 0%;
`
const RowContent = styled(Row)`
  margin-left: 2%;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/components/doughnut-chart.js